<template>
    <div class="engineer-container">
        <connection @change="connectionChanged" />
        <main class="main">
            <header class="header">
                <div class="header-left">
                    <img
                        src="/img/logos/black_white.png"
                        alt="SwiftWork"
                        class="engineer-logo"
                    >
                </div>
                <div class="header-right">
                    <span
                        class="online"
                        v-if="online"
                    >Online</span>
                    <span
                        class="offline"
                        v-if="!online"
                    >Offline</span>
                    <notifications-overview />
                    <i
                        class="nav-toggle fa fa-bars"
                        v-show="!sidebarToggled"
                        @click="toggleSidebar"
                    />
                    <i
                        class="nav-toggle fa fa-times"
                        v-show="sidebarToggled"
                        @click="toggleSidebar"
                    />
                </div>
                <div
                    class="header-title"
                    v-if="pageTitle"
                >
                    {{ pageTitle }}
                </div>
            </header>
            <aside
                class="sidebar"
                :class="{toggled : sidebarToggled}"
                @click="toggleSidebar"
            >
                <nav>
                    <ul>
                        <li>
                            <router-link
                                :to="{name: 'engineer.jobs.list'}"
                                exact
                            >
                                Jobs <i class="fa fa-briefcase" />
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{name: 'engineer.customers.search'}"
                                exact
                            >
                                Customers <i class="fa fa-users" />
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{name: 'engineer.overtime.index'}"
                                exact
                            >
                                Overtime <i class="far fa-clock" />
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{name: 'engineer.weeklyFunctionalTests.index'}"
                                exact
                            >
                                Weekly Functional Tests <i class="fa fas fa-clipboard-check" />
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{name: 'engineer.expenses.index'}"
                                exact
                            >
                                Expenses <i class="fa fas fa-receipt" />
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{name: 'engineer.calendar.index'}"
                                exact
                            >
                                Time Off & Absence <i class="fa fas fa-calendar" />
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{name: 'engineer.fe.index'}"
                                exact
                            >
                                Fire Extinguishers <i class="fa fas fa-fire-extinguisher" />
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{name: 'engineer.cpc-forms.index'}"
                                exact
                            >
                                CPD Forms <i class="fa fa-star" />
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{name: 'engineer.my_account'}"
                                exact
                            >
                                My Account <i class="fa fa-user" />
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{name: 'office.dashboard'}"
                                v-if="user && user.office_access"
                            >
                                Office Mode <i class="fa fa-desktop" />
                            </router-link>
                        </li>
                        <li>
                            <router-link
                                :to="{name: 'logout'}"
                                exact
                            >
                                Logout <i class="fa fa-sign-out-alt" />
                            </router-link>
                        </li>
                    </ul>
                </nav>
            </aside>
            <router-view />
            <error-message />
            <info-message />
        </main>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import AuthService from "../../services/AuthService";
import ConnectionComponent from "../ConnectionComponent.vue";
import NotificationsOverview from '../NotificationsOverviewComponent';

export default {
    components: {
        'connection': ConnectionComponent,
        NotificationsOverview,
    },
    data: function () {
        return {
            sidebarToggled: false,
            user: null,
            online: true
        };
    },

    computed: {
        ...mapState(['pageTitle']),
    },

    watch: {
        $route: {
            handler: function() {
                this.setPageTitle(this.$route.meta.title);
            },
            immediate: true,
        }
    },

    mounted: function () {
        AuthService.getUser().then(user => {
            this.user = user;
        });
    },

    methods: {
        ...mapMutations(['setPageTitle']),
        toggleSidebar: function () {
            this.sidebarToggled = !this.sidebarToggled;
        },
        connectionChanged: function (online) {
            this.online = online;
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/engineer/EngineerComponent.vue